import { Grid, Typography } from "@mui/material";
import { OLPaper } from "OLPaper";
import { Toggle } from "components/FormControls/Toggle";
import { useMessage } from "hooks/intl";
import { useStyles } from "./CollectionForm.styles";

interface Props {
  "data-test-id": string;
}

export const CollectionStatus = ({ "data-test-id": dataTestId }: Props) => {
  const classes = useStyles();
  const { message } = useMessage();

  return (
    <OLPaper className={classes.OLPaper}>
      <Grid container rowGap={8}>
        <Grid item xs={12}>
          <Toggle
            label={message({ id: "active" })}
            name="active"
            data-test-id={`${dataTestId}-toggle`}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography className={classes.inputInfo}>
            {message({ id: "collectionStatusInfo" })}
          </Typography>
        </Grid>
      </Grid>
    </OLPaper>
  );
};
